"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.array.find");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _vuedraggable = _interopRequireDefault(require("vuedraggable"));

var _elementUi = require("element-ui");

var _lastMileDelivery = require("@/mixins/last-mile-delivery/last-mile-delivery");

var _order = require("@/api/order.api");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LMDOrderTableColumnSelectorComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDOrderTableColumnSelectorComponent, _Mixins);

  var _super = _createSuper(LMDOrderTableColumnSelectorComponent);

  function LMDOrderTableColumnSelectorComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LMDOrderTableColumnSelectorComponent);
    _this = _super.apply(this, arguments);
    _this.isDialogVisible = false;
    _this.unselectedColumns = [];
    _this.columnKey = process.env.VUE_APP_LMD_COLUMN_KEY;
    _this.selectedTemplateName = 'newTemplate';
    _this.newTemplateName = '';
    _this.orderAPI = null;
    return _this;
  }

  (0, _createClass2.default)(LMDOrderTableColumnSelectorComponent, [{
    key: "cardInnerHeight",
    get: function get() {
      return "".concat(document.documentElement.clientHeight * 0.75, "px");
    }
  }, {
    key: "created",
    value: function created() {
      if (!this.orderAPI) {
        this.orderAPI = new _order.OrderAPI({
          lfToken: this.$lfToken || null,
          userSetting: this.$userSetting,
          userData: this.$userData
        });
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.initColumns();
    }
  }, {
    key: "initColumns",
    value: function initColumns() {
      var _this2 = this;

      // this.$selectedColumns = this.helper.cloneDeep(JSON.parse(window.localStorage.getItem(this.columnKey)) || this.$defaultOrderColumns);
      if (this.$orderColumnTemplates.length === 0) {
        this.selectedTemplateName = 'newTemplate';
        this.$selectedColumns = this.helper.cloneDeep(this.$defaultOrderColumns);
      } else {
        var tName = window.localStorage.getItem(this.columnKey);

        if (!this.helper.isUndefined(tName) && this.$orderColumnTemplates.find(function (t) {
          return t.templateName === tName;
        })) {
          this.selectedTemplateName = tName;
        } else {
          this.selectedTemplateName = this.$orderColumnTemplates[this.$orderColumnTemplates.length - 1].templateName;
        }

        var index = this.$orderColumnTemplates.findIndex(function (item) {
          return item.templateName === _this2.selectedTemplateName;
        });

        if (index !== -1) {
          var columns = JSON.parse(this.$orderColumnTemplates[index].columns);
          this.$selectedColumns = this.$defaultOrderColumns.filter(function (col) {
            return _this2.helper.includes(columns, col.code);
          }).sort(function (a, b) {
            return columns.indexOf(a.code) - columns.indexOf(b.code);
          });
          this.unselectedColumns = this.helper.differenceBy(this.$defaultOrderColumns, this.$selectedColumns, 'code');
        }
      }

      this.unselectedColumns = this.helper.differenceBy(this.$defaultOrderColumns, this.$selectedColumns, 'code');

      if (!this.hasAssemblyMinutes) {
        this.$selectedColumns = this.$selectedColumns.filter(function (col) {
          return _this2.isColumnFilteredOut(col['code'], 'assembly');
        });
        this.unselectedColumns = this.unselectedColumns.filter(function (col) {
          return _this2.isColumnFilteredOut(col['code'], 'assembly');
        });
      }
    }
  }, {
    key: "isColumnFilteredOut",
    value: function isColumnFilteredOut(col, type) {
      if (type === 'assembly') {
        return col !== 'serviceName' && col !== 'assemblyMinutes' && col !== 'wallMountQuantity' && col !== 'disposalQuantity' && col !== 'staircaseQuantity' && col !== 'pickPhoneNumber' && col !== 'dropPhoneNumber';
      }

      return col;
    }
  }, {
    key: "editColumns",
    value: function editColumns(type, column) {
      if (type === 'add') {
        this.$selectedColumns = [].concat((0, _toConsumableArray2.default)(this.$selectedColumns), [column]);
        this.unselectedColumns = this.unselectedColumns.filter(function (col) {
          return col['code'] !== column['code'];
        });
      }

      if (type === 'remove') {
        this.$selectedColumns = this.$selectedColumns.filter(function (col) {
          return col['code'] !== column['code'];
        });
        this.unselectedColumns.push(column);
      }
    }
  }, {
    key: "saveColumns",
    value: function saveColumns() {
      // window.localStorage.setItem(this.columnKey, JSON.stringify(this.$selectedColumns));
      this.resetVariables();
    }
  }, {
    key: "addNewTemplate",
    value: function () {
      var _addNewTemplate = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.$orderColumnTemplates.length === 0)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return this.postNewTemplate();

              case 3:
                _context.next = 7;
                break;

              case 5:
                _context.next = 7;
                return this.putCurrentTemplate();

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function addNewTemplate() {
        return _addNewTemplate.apply(this, arguments);
      }

      return addNewTemplate;
    }()
  }, {
    key: "removeTemplate",
    value: function () {
      var _removeTemplate = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.$orderColumnTemplates.length === 1)) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 3;
                return this.deleteAllTemplates();

              case 3:
                _context2.next = 7;
                break;

              case 5:
                _context2.next = 7;
                return this.deleteCurrentTemplate();

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function removeTemplate() {
        return _removeTemplate.apply(this, arguments);
      }

      return removeTemplate;
    }()
  }, {
    key: "postNewTemplate",
    value: function () {
      var _postNewTemplate = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var templateName, payload, res, message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                templateName = this.newTemplateName.trim();

                if (!this.helper.isUndefined(templateName)) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                payload = [{
                  templateName: templateName,
                  columns: JSON.stringify(this.$selectedColumns.map(function (col) {
                    return col['code'];
                  }))
                }];
                _context3.next = 6;
                return this.orderAPI.postOrderColumnTemplate({
                  templateType: this.columnKey,
                  columns: payload
                });

              case 6:
                res = _context3.sent;
                message = {
                  title: this.$i18n.t('notification.columnTemplate.insertSuccess'),
                  duration: 5000
                };

                if (res.status === 'success') {
                  this.$orderColumnTemplates = payload;

                  _elementUi.Notification.success(message);
                } else {
                  message.title = this.$i18n.t('notification.columnTemplate.insertFailed');

                  _elementUi.Notification.error(message);
                }

                this.resetVariables();

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function postNewTemplate() {
        return _postNewTemplate.apply(this, arguments);
      }

      return postNewTemplate;
    }()
  }, {
    key: "putCurrentTemplate",
    value: function () {
      var _putCurrentTemplate = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var templateName, index, payload, res, message;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                templateName = this.selectedTemplateName === 'newTemplate' ? this.newTemplateName.trim() : this.selectedTemplateName.trim();
                index = this.helper.findIndex(this.$orderColumnTemplates, function (t) {
                  return t.templateName === templateName;
                });
                payload = this.helper.cloneDeep(this.$orderColumnTemplates);

                if (!this.helper.isUndefined(templateName)) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return");

              case 5:
                if (index === -1) {
                  payload.push({
                    templateName: templateName,
                    columns: JSON.stringify(this.$selectedColumns.map(function (col) {
                      return col['code'];
                    }))
                  });
                } else {
                  payload[index].columns = JSON.stringify(this.$selectedColumns.map(function (col) {
                    return col['code'];
                  }));
                }

                _context4.next = 8;
                return this.orderAPI.putOrderColumnTemplate({
                  templateType: this.columnKey,
                  columns: payload
                });

              case 8:
                res = _context4.sent;
                message = {
                  title: this.$i18n.t('notification.columnTemplate.updateSuccess'),
                  duration: 5000
                };

                if (res.status === 'success') {
                  this.$orderColumnTemplates = payload;

                  _elementUi.Notification.success(message);
                } else {
                  message.title = this.$i18n.t('notification.columnTemplate.updateFailed');

                  _elementUi.Notification.error(message);
                }

                this.resetVariables();

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function putCurrentTemplate() {
        return _putCurrentTemplate.apply(this, arguments);
      }

      return putCurrentTemplate;
    }()
  }, {
    key: "deleteCurrentTemplate",
    value: function () {
      var _deleteCurrentTemplate = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var templateName, index, payload, res, message;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                templateName = this.selectedTemplateName.trim();

                if (!this.helper.isUndefined(templateName)) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt("return");

              case 3:
                index = this.helper.findIndex(this.$orderColumnTemplates, function (t) {
                  return t.templateName === templateName;
                });
                payload = this.helper.cloneDeep(this.$orderColumnTemplates);

                if (!(index === -1)) {
                  _context5.next = 7;
                  break;
                }

                return _context5.abrupt("return", false);

              case 7:
                payload.splice(index, 1);
                _context5.next = 10;
                return this.orderAPI.putOrderColumnTemplate({
                  templateType: this.columnKey,
                  columns: payload
                });

              case 10:
                res = _context5.sent;
                message = {
                  title: this.$i18n.t('notification.columnTemplate.deleteSuccess'),
                  duration: 5000
                };

                if (res.status === 'success') {
                  this.$orderColumnTemplates = payload;

                  _elementUi.Notification.success(message);
                } else {
                  message.title = this.$i18n.t('notification.columnTemplate.deleteFailed');

                  _elementUi.Notification.error(message);
                }

                this.resetVariables('delete');

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function deleteCurrentTemplate() {
        return _deleteCurrentTemplate.apply(this, arguments);
      }

      return deleteCurrentTemplate;
    }()
  }, {
    key: "deleteAllTemplates",
    value: function () {
      var _deleteAllTemplates = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res, message;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.orderAPI.deleteOrderColumnTemplate(this.columnKey);

              case 2:
                res = _context6.sent;
                message = {
                  title: this.$i18n.t('notification.columnTemplate.deleteAllSuccess'),
                  duration: 5000
                };

                if (res.status === 'success') {
                  this.$orderColumnTemplates = [];

                  _elementUi.Notification.success(message);
                } else {
                  message.title = this.$i18n.t('notification.columnTemplate.deleteAllFailed');

                  _elementUi.Notification.error(message);
                }

                this.selectedTemplateName = 'newTemplate';
                this.newTemplateName = '';
                window.localStorage.setItem(this.columnKey, this.selectedTemplateName);
                this.$selectedColumns = this.$defaultOrderColumns;
                this.unselectedColumns = this.helper.differenceBy(this.$defaultOrderColumns, this.$selectedColumns, 'code');
                this.isDialogVisible = false;

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function deleteAllTemplates() {
        return _deleteAllTemplates.apply(this, arguments);
      }

      return deleteAllTemplates;
    }()
  }, {
    key: "handleTemplateChanges",
    value: function handleTemplateChanges(templateName) {
      var _this3 = this;

      if (templateName === 'newTemplate') {
        this.$selectedColumns = this.helper.cloneDeep(this.$defaultOrderColumns);
        this.unselectedColumns = this.helper.differenceBy(this.$defaultOrderColumns, this.$selectedColumns, 'code');
      } else {
        this.newTemplateName = '';
        var index = this.$orderColumnTemplates.findIndex(function (item) {
          return item.templateName === templateName;
        });

        if (index !== -1) {
          var columns = JSON.parse(this.$orderColumnTemplates[index].columns);
          this.$selectedColumns = this.$defaultOrderColumns.filter(function (col) {
            return _this3.helper.includes(columns, col.code);
          });
          this.unselectedColumns = this.helper.differenceBy(this.$defaultOrderColumns, this.$selectedColumns, 'code');
        }
      }
    }
  }, {
    key: "resetVariables",
    value: function resetVariables() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var templateName = null;

      if (this.$orderColumnTemplates.length === 0 || this.selectedTemplateName === 'newTemplate') {
        templateName = this.newTemplateName;
      } else {
        templateName = this.selectedTemplateName;
      }

      if (!this.helper.isUndefined(type)) {
        templateName = this.$orderColumnTemplates[this.$orderColumnTemplates.length - 1].templateName;
        var index = this.$orderColumnTemplates.findIndex(function (item) {
          return item.templateName === templateName;
        });

        if (index !== -1) {
          var columns = JSON.parse(this.$orderColumnTemplates[index].columns);
          this.$selectedColumns = this.helper.cloneDeep(columns);
          this.unselectedColumns = this.helper.differenceBy(this.$defaultOrderColumns, this.$selectedColumns, 'code');
        }
      }

      window.localStorage.setItem(this.columnKey, templateName);
      this.selectedTemplateName = templateName;
      this.newTemplateName = '';
      this.isDialogVisible = false;
    }
  }]);
  return LMDOrderTableColumnSelectorComponent;
}((0, _vuePropertyDecorator.Mixins)(_lastMileDelivery.LastMileDeliveryMixin));

LMDOrderTableColumnSelectorComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDOrderTableColumnSelectorComponent',
  components: {
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-dialog': _elementUi.Dialog,
    'el-tooltip': _elementUi.Tooltip,
    'el-button': _elementUi.Button,
    'el-card': _elementUi.Card,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'draggable': _vuedraggable.default,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-input': _elementUi.Input
  }
})], LMDOrderTableColumnSelectorComponent);
var _default = LMDOrderTableColumnSelectorComponent;
exports.default = _default;